__turbopack_context__.v({
  "input": "Input-module-scss-module__x-o31W__input",
  "root": "Input-module-scss-module__x-o31W__root",
  "textarea": "Input-module-scss-module__x-o31W__textarea",
});
